/**
 * Mutación para setear los datos iniciales del filtro.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setFilterProductsFilledAttachment(state, nextState) {
    state.filterProductsFilledAttachment = nextState
}

